module.exports = __webpack_public_path__ + "img/chevron-right.ed57bb9f.svg";